<template>
  <div class>
    <div class="container" v-if="sections.suggestions">
      <div class="row suggestion d-flex">
        <div class="col-3 title">
          <div class="content">
            <PerfectScrollbar :options="settings">
              <div class="title-list d-flex align-items-center no-hover">
                <span class="typo-heading16 typo-medium text-light-high">{{ suggestTitle }}</span>
              </div>
              <div v-for="(item, index) in suggest.items" :key="index" class="title-list d-flex align-items-center" @click="chooseContent(index)" :class="{ selected: index == chosenIndex }">
                <span class="text-light-high mr-xl-2 mr-mlg-1 mr-lg-1" :key="Date.now() + item.title">{{ getLocaleText(item.title) }}</span>
                <div class="ml-auto">
                  <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="index == chosenIndex">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.14766 9.89777L0.352167 9.10227L4.45442 5.00002L0.352168 0.897767L1.14766 0.102272L6.04541 5.00002L1.14766 9.89777Z" fill="#212121" />
                  </svg>
                </div>
              </div>
            </PerfectScrollbar>
          </div>
        </div>
        <div class="detail" :class="suggestClass">
          <PerfectScrollbar :settings="settings">
            <transition name="fade" mode="out-in">
              <div class="content d-flex" :key="chosenIndex">
                <div class="thumbnail mb-2">
                  <img v-lazyload :data-src="suggest.items[chosenIndex].img1_url" :src="suggest.items[chosenIndex].img2_url" alt />
                  <!-- <img class="thumbnail-col-9" v-else :src="suggest.items[chosenIndex].img2_url" alt /> -->
                </div>
                <div class="content-text">
                  <!-- <transition name="component-fade">
                <p
                  class="typo-button14 typo-medium text-light-high mb-1"
                >{{suggest.items[chosenIndex].content.title}}</p>
                  </transition>-->

                  <p class="typo-button14 typo-medium text-light-high mb-1" @click="openURL(suggest.items[chosenIndex].settings.url)">{{ chosenTitle }}</p>
                  <p class="typo-paragraph12 typo-regular typo-lh150 text-light-low">{{ chosenContent }}</p>
                </div>
                <a class="mt-auto typo-paragraph12 typo-medium text-mono3" @click.prevent="checkPreventClick(suggest.items[chosenIndex].settings.url)" :href="suggest.items[chosenIndex].settings.url" target="_blank">{{ $t("dashboard.blogs.readMore") }}</a>
              </div>
            </transition>
          </PerfectScrollbar>
        </div>
        <div class="col-4 upgrade-box pr-0 pl-3" v-if="shopInfo.plan == 'trial' || shopInfo.plan == 'starter'" :class="classList">
          <div class="content d-flex">
            <div class="title mb-1">
              <span>{{ upgradeBox.title }}</span>
            </div>
            <div class="context-text typo-paragraph12 typo-regular typo-lh150" v-html="upgradeBox.content"></div>
            <!-- <p>* Product Pages & Landing Pages Design</p>
            <p>* Premium Templates from the Library</p>
            <p>* High-Speed CDN for your Pages</p>

            <p>Fact: 10,000 successful stores are updating their store‘s look & feel and design landing pages for their marketing campaigns.</p> -->
            <button v-if="classList['trial-expired']" class="btn btn-outline btn-block btn-extend mt-auto mb-1 d-flex" @click="openLiveChat()">
              <svg class="mr-1" width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4.5" cy="4.5" r="4" fill="#06E884" />
              </svg>

              <span>{{ $t("generals.liveChatExtend") }}</span>
            </button>

            <button v-if="classList['need-upgrade']" @click="$router.replace({ name: 'Pricing' })" class="btn btn-primary btn-block mt-auto">{{ $t("generals.upgradeNow") }}</button>
            <button v-else @click="$router.replace({ name: 'Pricing' })" class="btn btn-outline btn-block ">{{ $t("generals.upgradeNow") }}</button>
          </div>
        </div>
        <div class="col-4 pr-0 pl-3 plan-box" v-else>
          <div class="bg-light1 p-3 content d-flex flex-column">
            <h2 class="text-light-high title">{{ $t("suggest.letCreate") }}</h2>
            <div class="img-block py-1">
              <div class="image-group">
                <img class="image mobile" :src="require('@/core/assets/images/create-mobile.png')" />
                <img class="image desktop" :src="publicPath + require('@/core/assets/images/create-desktop.png')" />
              </div>
            </div>

            <p class="typo-paragraph14 typo-regular-150 text-light-low mb-1">{{ $t("suggest.winMore") }}</p>
            <button @click="$router.replace({ name: 'LandingPagesTemplate' })" class="btn btn-lg btn-block btn-primary typo-button14 typo-medium text-dark-high mt-auto">{{ $t("suggest.createLanding") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import MyText from "./Suggest/MyText";
import { mapGetters } from "vuex";
import getLocale from "@/mixins/getLocale.js";

export default {
  name: "Suggest",
  components: {
    // MyText
  },
  mixins: [getLocale],
  props: {
    shopInfo: Object
  },
  data() {
    return {
      chosenIndex: 0,
      settings: {
        handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
        wheelPropagation: true,
        wheelSpeed: 0.1
      }
    };
  },
  computed: {
    ...mapGetters("tutorial", {
      sections: "sections"
    }),
    suggest() {
      if (!this.sections.suggestions) {
        return [];
      }
      if (this.shopInfo.plan == "trial" && this.sections.suggestions) {
        return this.sections.suggestions.trial;
      }
      return this.sections.suggestions.upgraded;
    },
    classList() {
      if (this.shopInfo.plan == "trial" && this.shopInfo.remainingDays <= 3) {
        return { "trial-expired": true };
      }
      if (this.shopInfo.plan == "trial" || this.shopInfo.plan == "starter") {
        return { "need-upgrade": true };
      }
      return {
        null: true
      };
    },
    upgradeBox() {
      if (this.classList["trial-expired"] == true) {
        return {
          title: this.$t("suggest.upgradeBox.title1"),
          content: this.$t("suggest.upgradeBox.content1").replace("**user name**", this.shopInfo.firstName + " " + this.shopInfo.lastName)
        };
      }
      return {
        title: this.$t("suggest.upgradeBox.title2.business"),
        content: this.$t("suggest.upgradeBox.content2")
      };
    },
    suggestClass() {
      if (this.shopInfo.plan == "trial" && this.shopInfo.remainingDays <= 0) {
        return { "col-5": true };
      }
      if (this.shopInfo.plan == "trial" || this.shopInfo.plan == "starter") {
        return { "col-5": true };
      }
      return {
        "col-5": true,
        "pr-0": true
      };
    },
    suggestTitle() {
      return this.$t("suggest.title");
    },
    chosenTitle() {
      return this.getLocaleText(this.suggest.items[this.chosenIndex].title);
    },
    chosenContent() {
      return this.getLocaleText(this.suggest.items[this.chosenIndex].content);
    }
  },
  methods: {
    onTabChangeHandler() {},
    chooseContent(i) {
      this.chosenIndex = i;
    },
    openLiveChat() {
      this.$chatbox.show();
    },
    openURL(url) {
      if (url?.includes("ecomsolid_modal")) {
        this.$emit("openModalEcom");
        return;
      }
      window.open(url, "_blank");
    },
    checkPreventClick(url) {
      if (url?.includes("ecomsolid_modal")) {
        this.$emit("openModalEcom");
        return;
      }
      window.open(url, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
$height: 375px;
$height-lg: 300px;

.suggestion {
  margin-top: 32px;
  min-height: $height;
  max-height: $height;
  .title {
    background: $light1;
    padding: 0px;
    height: fit-content;
    border-radius: $radius 0 0 $radius;
    .content {
      padding: 0px !important;
      background: $light1;
      border-radius: $radius 0 0 $radius;
      .ps {
        position: relative;
        height: $height;
      }
      .title-list {
        > div {
          min-width: 7px;
          max-width: 7px;
        }
        padding: 9px 15px 11px 16px;
        min-height: 66px;
        max-height: 66px;
        border-bottom: 1px solid $light3;
        border-right: 1px solid $light3;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
        transition: all ease 0.3s;

        > span {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden !important;
          text-overflow: ellipsis;
        }
        &:first-child {
          padding: 16px 24px 14px 24px;
          font-weight: 500;
          font-size: 16px;
          line-height: 19px;
          @media screen and (min-width: 1440px) {
            min-height: 50px;
            max-height: 50px;
          }
        }
        cursor: pointer;
        &:hover {
          background: $light2;
        }
        &.selected {
          background: $light2;
        }
        &:last-child {
          border-bottom: 1px solid $light1;
          &:hover {
            border-bottom: 1px solid $light2;
          }
        }
      }
    }
  }
  .detail {
    padding-left: 0px;
    padding-right: 0px;
    background: $light1;
    padding-top: 24px;
    padding-bottom: 16px;
    height: fit-content;
    border-radius: 0 $radius $radius 0;
    .ps {
      position: relative;
      height: $height - 40px;
    }
    .content {
      flex-direction: column;
      background: $light1;
      padding: 0px 24px 0px 24px;
      height: 100%;
      .thumbnail {
        // height: auto;
        max-height: 130px;
        img {
          width: 100%;
          max-height: 130px;
          // width: auto;
          object-fit: cover;
          // height: auto;
          // height: 213px;
        }
        &-col-9 {
          max-width: 373px;
        }
      }
      .content-text {
        p:first-child {
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden !important;
          text-overflow: ellipsis;
        }
        p:nth-child(2) {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 5;
          -webkit-box-orient: vertical;
          overflow: hidden !important;
          text-overflow: ellipsis;
        }
      }
      > a {
        padding: 8px 8px 0px 8px;
        margin-left: -8px;
        margin-right: -8px;
        width: max-content;
        display: inline-block;
      }
    }
  }
  .content {
    // background: $light1;
    // padding: 24px;
    // height: 100%;
  }
  .upgrade-box {
    padding-left: 11px;
    .content {
      border-radius: $radius;
    }
    .btn-extend {
      background: inherit;
      white-space: nowrap;
      padding-left: 0px;
      padding-right: 0px;
      color: $light1;
    }
    &.need-upgrade {
      .content {
        background: $light1;
        padding: 24px;
        height: 100%;
        flex-direction: column;
        align-items: flex-start;
        background: $light1;
        .title {
          font-family: Inter;
          font-style: normal;
          font-weight: bold;
          font-size: 32px;
          line-height: 39px;
          color: $mono3;
        }
        .context-text {
          color: $textLightModeLow;
        }
        button {
          padding-top: 11px;
          padding-bottom: 11px;
        }
      }
    }

    &.trial-expired {
      .content {
        background: $light1;
        padding: 24px;
        height: 100%;
        flex-direction: column;
        align-items: flex-start;
        background: $mono3;
        .title {
          font-family: Inter;
          font-style: normal;
          font-weight: bold;
          font-size: 32px;
          line-height: 39px;
          color: $textDarkModeHigh;
          background: $mono3;
        }
        .context-text {
          color: $textDarkModeHigh;
        }
        button {
          border: 1px solid $light1;
          padding-top: 11px;
          padding-bottom: 11px;
          &:hover {
            border: 1px solid $light2;
          }
        }
      }
    }
  }

  .plan-box {
    .content {
      height: 100%;
      .title {
        font-size: 30px;
        line-height: 36px;
      }
      .img-block {
        @include flex-center;
        .image-group {
          position: relative;
          .image {
            &.mobile {
              position: absolute;
              bottom: 17px;
              left: -20px;
              box-shadow: 0px 0.332071px 0.719487px rgba(0, 0, 0, 0.0168687), 0px 0.798012px 1.72903px rgba(0, 0, 0, 0.0242336), 0px 1.50259px 3.2556px rgba(0, 0, 0, 0.03), 0px 2.68036px 5.80744px rgba(0, 0, 0, 0.0357664), 0px 5.01331px 10.8622px rgba(0, 0, 0, 0.0431313), 0px 12px 26px rgba(0, 0, 0, 0.06);
            }
            &.desktop {
              box-shadow: 0px 0.332071px 0.719487px rgba(0, 0, 0, 0.0168687), 0px 0.798012px 1.72903px rgba(0, 0, 0, 0.0242336), 0px 1.50259px 3.2556px rgba(0, 0, 0, 0.03), 0px 2.68036px 5.80744px rgba(0, 0, 0, 0.0357664), 0px 5.01331px 10.8622px rgba(0, 0, 0, 0.0431313), 0px 12px 26px rgba(0, 0, 0, 0.06);
            }
          }
        }
      }
      .btn {
        white-space: nowrap;
      }
    }
  }
}

@media screen and (min-width: 1024px) and (max-width: 1279px) {
  .suggestion {
    min-height: $height-lg;
    max-height: $height-lg;
    .title {
      .content {
        .ps {
          height: $height-lg;
        }
        .title-list {
          padding: 8px 8px 8px 16px;
          min-height: 50px;
          max-height: 50px;
          font-size: 10px;
          line-height: 12px !important;
          &:first-child {
            padding: 11px 16px;
            font-weight: 500;
            font-size: 14px;
            line-height: 17px;
          }
        }
      }
    }
    .detail {
      padding-left: 0px;
      padding-top: 16px;
      padding-bottom: 16px;
      .ps {
        height: $height-lg - 33px;
      }
      .content {
        padding: 0px 16px;
        flex-direction: column;
        .thumbnail {
          max-height: 88px;
          img {
            width: 100%;
            max-height: 88px;
            // width: auto;
            object-fit: cover;
            // height: auto;
            // height: 213px;
          }
          &-col-9 {
            max-width: 305px;
          }
        }
        .content-text {
          p:first-child {
            font-family: Inter;
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 15px;
          }
          p:nth-child(2) {
            font-size: 10px;
            line-height: 150%;
          }
        }
      }
    }
    .upgrade-box {
      button {
        height: 36px;
        padding: 0px;
        font-size: 12px;
      }
      &.need-upgrade {
        .content {
          padding: 16px;
          .title {
            font-size: 24px;
            line-height: 31px;
          }
          .context-text {
            font-size: 10px;
            line-height: 150%;
          }
          button {
          }
        }
      }

      &.trial-expired {
        .content {
          padding: 16px;
          .title {
            font-size: 24px;
            line-height: 31px;
          }
          .context-text {
            font-size: 10px;
            line-height: 150%;
          }
          button {
          }
        }
      }
    }
    .plan-box {
      .content {
        .title {
          font-size: 18px;
          line-height: 21px;
        }
      }
      .img-block {
        zoom: 0.7;
      }
    }
  }
}

@media screen and (min-width: 1024px) and (max-width: 1279px) {
  .suggestion {
    .plan-box {
      .content {
        padding-left: 16px !important;
        padding-right: 16px !important;
      }
    }
  }
}

@media screen and (min-width: 1280px) and (max-width: 1439px) {
  .suggestion {
    min-height: $height-lg;
    max-height: $height-lg;
    .title {
      .content {
        .ps {
          height: $height-lg;
        }
        .title-list {
          padding: 8px 8px 8px 16px;
          min-height: 50px;
          max-height: 50px;
          font-size: 12px;
          line-height: 15px !important;
          &:first-child {
            padding: 11px 16px;
            font-weight: 500;
            font-size: 14px;
            line-height: 17px;
          }
        }
      }
    }
    .detail {
      padding-left: 0px;
      padding-top: 16px;
      padding-bottom: 16px;
      .ps {
        height: $height-lg - 33px;
      }
      .content {
        padding: 0px 16px;
        flex-direction: column;
        .thumbnail {
          max-height: 88px;
          img {
            width: 100%;
            max-height: 88px;
            // width: auto;
            object-fit: cover;
            // height: auto;
            // height: 213px;
          }
          &-col-9 {
            max-width: 305px;
          }
        }
        .content-text {
          p:first-child {
            font-family: Inter;
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 15px;
          }
          p:nth-child(2) {
            font-size: 12px;
            line-height: 150%;
          }
        }
      }
    }
    .upgrade-box {
      button {
        height: 36px;
        padding: 0px;
        font-size: 12px;
      }
      &.need-upgrade {
        .content {
          padding: 16px;
          .title {
            font-size: 26px;
            line-height: 31px;
          }
          .context-text {
            font-size: 12px;
            line-height: 150%;
          }
          button {
          }
        }
      }

      &.trial-expired {
        .content {
          padding: 16px;
          .title {
            font-size: 26px;
            line-height: 31px;
          }
          .context-text {
            font-size: 12px;
            line-height: 150%;
          }
          button {
          }
        }
      }
    }
    .plan-box {
      .content {
        .title {
          font-size: 26px;
          line-height: 31px;
        }
      }
      .img-block {
        zoom: 0.7;
      }
    }
  }
}
</style>
